"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _icon_wrapper = _interopRequireDefault(require("./icon_wrapper"));
var _templateObject, _class, _FlagBsIcon;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Wrapper = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: 50%;\n  display: inline-block;\n  overflow: hidden;\n  width: ", ";\n  height: ", ";\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.width;
});
var FlagBsIcon = (0, _mobxReact.observer)(_class = (_FlagBsIcon = /*#__PURE__*/function (_React$Component) {
  function FlagBsIcon() {
    _classCallCheck(this, FlagBsIcon);
    return _callSuper(this, FlagBsIcon, arguments);
  }
  _inherits(FlagBsIcon, _React$Component);
  return _createClass(FlagBsIcon, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(Wrapper, {
        width: this.props.width
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        viewBox: "0 0 106 100",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("rect", {
        id: "Rectangle",
        fill: "#001E96",
        x: "6",
        y: "0",
        width: "100",
        height: "100"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        fill: "#FECC00",
        points: "6 0 85.3 0 85.3 100 6 20.7"
      }), /*#__PURE__*/_react["default"].createElement("g", {
        id: "Group",
        transform: "translate(0.000000, 27.000000)",
        fill: "#F0F0F0"
      }, /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "9.1 5.8 7.4 0.7 5.7 5.8 0.3 5.8 4.7 9 3 14.1 7.4 10.9 11.7 14.1 10.1 9 14.4 5.8"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "18.2 15 16.5 9.9 14.9 15 9.5 15 13.9 18.2 12.2 23.3 16.5 20.1 20.9 23.3 19.2 18.1 23.6 15"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "27.4 24.1 25.7 19 24 24.1 18.7 24.2 23 27.3 21.4 32.4 25.7 29.3 30.1 32.4 28.4 27.3 32.7 24.1"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "36.5 33.3 34.9 28.2 33.2 33.3 27.8 33.3 32.2 36.5 30.5 41.6 34.9 38.4 39.2 41.6 37.6 36.5 41.9 33.3"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "45.7 42.5 44 37.3 42.4 42.5 37 42.5 41.3 45.6 39.7 50.7 44 47.6 48.4 50.7 46.7 45.6 51.1 42.5"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "54.8 51.6 53.2 46.5 51.5 51.6 46.1 51.6 50.5 54.8 48.8 59.9 53.2 56.7 57.5 59.9 55.9 54.8 60.2 51.6"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "64 60.8 62.3 55.7 60.7 60.8 55.3 60.8 59.6 63.9 58 69.1 62.3 65.9 66.7 69.1 65 63.9 69.4 60.8"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "71.5 64.8 69.8 69.9 64.4 69.9 68.7 73 74.3 73 78.5 69.9 73.2 69.9"
      })))));
    }
  }]);
}(_react["default"].Component), _FlagBsIcon.defaultProps = {
  width: '20px'
}, _FlagBsIcon)) || _class;
var _default = exports["default"] = (0, _icon_wrapper["default"])(FlagBsIcon);